module.exports = __webpack_public_path__ + "fonts/Muli-Regular.79ba0ab4.woff2";